var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<span ng-class=\"{salvataggioInCorso: asctrl.salvataggio.incorso, salvataggioSuccess: asctrl.salvataggio.success, salvataggioError: asctrl.salvataggio.error}\">\n<span ng-transclude></span>\n<span ng-if=\"asctrl.salvataggio.incorso\"><i class=\"fa fa-spinner fa-pulse fa-fw\"></i></span>\n</span>";
var id1="autosavetpl.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;